import { AclDataProvider } from './AclDataProvider'
import AclContainer from './AclContainer'

export default ACLWrapper = (props) ->
  <AclDataProvider>
    <AclContainer {props...} />
  </AclDataProvider>
